import React from 'react';

import { IQuestion } from 'modules/national-certificate';

import Options from './options';
import TopSection from './top-section';

interface IProps {
  data?: IQuestion;
  subject?: string;
}

const SimpleQuestion: React.FC<IProps> = ({ data, subject }) => (
  <div className="shadow-xs space-y-3 rounded-xl bg-white px-4 py-3">
    <div className="px-1">
      <TopSection
        subject={subject}
        checked={data?.checked}
        testImage={data?.image}
        questionId={data?.question_id}
        title={data?.question_name}
      />
    </div>
    <Options checkedId={Number(data?.checked)} testId={data?.id} options={data?.options} isHorizontal />
  </div>
);

export default SimpleQuestion;
